import classNames from 'classnames'
import React from 'react'
import style from '../styles/buttons.module.scss'
import { Status } from '../types'

interface IProps {
  children?: any
  status: Status
  isCurrent?: boolean
  isDisabled?: boolean
  onClick?: () => void
}

const FiltersButton = ({
  children,
  status,
  isCurrent = false,
  isDisabled = false,
  onClick
}: IProps): React.ReactElement => {
  return (
    <button
      className={classNames({
        [style.filterbtn]: true,
        [style[`filterbtn--${status}`]]: true,
        [style['filterbtn--current']]: isCurrent,
        [style['filterbtn--current']]: isCurrent
      })}
      disabled={isDisabled}
      onClick={onClick}
    >
      {children}
    </button>
  )
}

export default FiltersButton
